const state = {
    data: {},
}

const getters = {
    getDataTransduson() {
        return state.data;
    }
}

const actions = {}

const mutations = {
    async setDataTransduson(data) {
        // const arr = payload[0].replace("[", "").replace("]", "").split(',');
        // const res = {};
        // arr.forEach((el, index) => res[state.keys[index]] = el);
        // res['phone'] = payload[1];
        // res['type'] = 'phone';
        // state.data = res;
        let dataEvent = data.split('||');

       state.data = {
            queue: dataEvent[0],
            name: dataEvent[1],
            phone: dataEvent[1],
            protocol: dataEvent[2],
            type: 'phone'
       }
       return state.data;
    },

    async delDataTransduson() {
        state.data = {}
    },

    async setChatData(data){
        console.log({ data });
        let obj = {Protocolo: data.protocol, phone: data.phone, type: 'chat', name: data.name, queue: data.queue, sessionDate: data.sessionDate};
        state.data = obj;
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
